var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_922234848"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M114 196l0 0c-2,0 -3,2 -3,4 0,1 1,2 3,2 0,0 0,0 0,0l1 0c2,0 3,-1 3,-3 -1,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M103 197c0,0 0,0 0,0 -1,0 -1,0 -1,0 -53,0 -96,-43 -96,-95 0,-53 43,-96 96,-96 52,0 95,43 95,96 0,14 -3,28 -10,41 0,2 0,3 2,4 1,1 3,0 4,-1 7,-14 10,-29 10,-44 0,-28 -10,-53 -30,-72 -19,-19 -44,-30 -71,-30 -28,0 -53,11 -72,30 -19,19 -30,44 -30,72 0,27 11,52 30,71 19,20 44,30 72,30 0,0 0,0 1,0 2,0 3,-1 3,-3 0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M171 111l-6 0c-1,0 -2,1 -3,2 0,3 -1,6 -2,9 -1,2 0,3 2,4 2,1 3,0 4,-2 1,-2 2,-5 2,-7l3 0c8,0 15,-7 15,-15 0,-9 -7,-16 -15,-16l-3 0c-2,-7 -4,-14 -9,-21l2 -1c6,-6 6,-16 0,-22 -6,-6 -15,-6 -21,0l-2 2c-7,-4 -14,-7 -21,-9l0 -2c0,-9 -7,-16 -15,-16 -9,0 -16,7 -16,16l0 2c-7,2 -14,5 -21,9l-1 -2c-6,-6 -16,-6 -22,0 -3,3 -5,7 -5,11 0,4 2,8 5,11l2 1c-4,7 -7,14 -9,21l-2 0c-9,0 -16,7 -16,16 0,8 7,15 16,15l2 0c2,7 5,14 9,21l-2 2c-3,2 -5,6 -5,10 0,5 2,8 5,11 6,6 16,6 22,0l1 -2c7,5 14,7 21,9l0 3c0,8 7,15 16,15 8,0 15,-7 15,-15l0 -3c2,0 5,-1 7,-2 2,-1 3,-2 2,-4 -1,-2 -2,-3 -4,-2 -3,1 -6,2 -9,2 -1,1 -2,2 -2,3l0 6c0,5 -4,9 -9,9 -5,0 -9,-4 -9,-9l0 -6c0,-1 -1,-2 -3,-3 -8,-1 -16,-4 -23,-9 -1,-1 -3,-1 -4,0l-4 4c-3,3 -9,3 -13,0 -1,-2 -2,-4 -2,-7 0,-2 1,-4 2,-6l4 -4c1,-1 1,-2 0,-4 -4,-7 -8,-14 -9,-23 0,-1 -2,-2 -3,-2l-5 0c-5,0 -9,-4 -9,-9 0,-5 4,-9 9,-9l5 0c1,0 3,-1 3,-3 1,-8 5,-16 9,-23 1,-1 1,-3 0,-4l-4 -4c-1,-2 -2,-4 -2,-6 0,-3 1,-5 2,-7 4,-3 10,-3 13,0l4 4c1,1 3,1 4,0 7,-4 15,-8 23,-9 2,0 3,-2 3,-3l0 -5c0,-5 4,-9 9,-9 5,0 9,4 9,9l0 5c0,1 1,3 2,3 9,1 16,5 23,9 2,1 3,1 4,0l4 -4c4,-3 9,-3 13,0 3,4 3,10 0,13l-4 4c-1,1 -1,3 0,4 5,7 8,15 9,23 1,2 2,3 3,3l6 0c5,0 9,4 9,9 0,5 -4,9 -9,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M127 193l-1 1c-1,0 -2,2 -2,3 0,2 2,3 3,3 0,0 1,0 1,0l0 0c2,-1 3,-3 3,-4 -1,-2 -3,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M163 134c0,0 0,0 0,0 -2,-2 -5,-3 -9,-3 -2,0 -4,0 -5,1l-6 -6c11,-18 8,-43 -7,-59 -19,-18 -50,-18 -68,0 -10,10 -15,22 -15,34 0,13 5,25 15,34 9,10 21,15 34,15 8,0 17,-3 24,-7l6 6c-1,1 -1,3 -1,5 0,4 1,6 3,9l37 37c2,2 5,3 8,3 3,0 6,-1 9,-3l12 -12c4,-5 4,-12 0,-17l-37 -37zm-38 2c0,0 0,0 0,0 -7,5 -15,7 -23,7 -12,0 -22,-4 -30,-12 -8,-8 -12,-18 -12,-30 0,-11 4,-21 12,-29 8,-8 19,-12 30,-12 10,0 21,4 29,12 14,14 16,37 5,53 0,0 0,0 0,0 -1,2 -3,4 -5,6 -2,2 -4,3 -6,5zm7 3c1,-1 2,-2 4,-4 1,-1 2,-2 3,-3l5 4 -8 8 -4 -5zm63 44l-12 12c-2,2 -5,2 -7,0l-37 -37c-1,-1 -2,-2 -2,-4 0,-1 1,-2 2,-3l12 -12c1,-1 2,-2 3,-2 2,0 3,1 4,2l37 37c2,2 2,5 0,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M78 78c-13,13 -13,34 0,47 7,6 15,10 24,10 8,0 17,-4 23,-10 13,-13 13,-34 0,-47 -13,-13 -34,-13 -47,0zm42 42c-5,6 -12,8 -18,8 -7,0 -14,-2 -19,-8 -11,-10 -11,-27 0,-37 10,-11 27,-11 37,0 11,10 11,27 0,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M143 187l0 0c-2,1 -3,3 -2,5 1,1 2,2 3,2 1,0 1,-1 1,-1l1 0c1,-1 2,-3 1,-4 -1,-2 -2,-2 -4,-2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.f37daf2ab4e72fc00be3206111d3b736.svg";
export { ForwardRef as ReactComponent };